
const drawerEvents = {
    OnLineItemUpdate: 'action:cart:updateLineItem',
    onQuantityChange: 'on:QuantityChange',
    triggerCartChange: 'action:cart:updateCart',
};

class DrawerCart extends HTMLElement {
    constructor() {
        super();
        this.currentLineItem;
        this.lineItemError = null;
        this.cartIdentifier = this.getAttribute('render-section');
        this.checkoutContainer = document.querySelector(
            '[cart-checkout-container]'
        );

        this.sectionId =
            this.getAttribute('data-sectionId') || this.cartIdentifier;

        this.addEventListener(
            _EVENT_HELPER.OnLineItemUpdate,
            this.handleLineItem.bind(this)
        );

        document.addEventListener(
            _EVENT_HELPER.triggerCartChange,
            this.renderCart.bind(this)
        );

        document.addEventListener(
            _EVENT_HELPER.updateAndShowCart,
            this.fetchAndRenderCartItems.bind(this)
        );

        document.addEventListener(
            _EVENT_HELPER.showCartPopup,
            (e) => {
                this.renderCartContents(e.detail);
            }
        );
    }

    _getCartItemCount(data) {
        const cartSection = data.sections[this.cartIdentifier];

        const parseCartSectionHTML = new DOMParser().parseFromString(
            cartSection,
            'text/html'
        );

        return parseCartSectionHTML.querySelector(this.tagName).dataset
            .cartitemcount;
    }

    renderCart(e) {
        this.renderCartContents(e.detail);
        this.renderElementsBasedOnCartItems(e.detail);

        if (
            this.cartIdentifier == 'cart-drawer' &&
            !this.closest('cart-drawer-component').isDrawerOpen
        ) {
            HELPER_UTIL.dispatchCustomEvent(
                _EVENT_HELPER.showDrawer,
                this,
                {
                    drawerType: 'cart-drawer',
                }
            );
        }
    }

    _get(property) {
        return this[property];
    }

    _set(property, value) {
        this[property] = value;
    }

    showDrawerToastMessage({ responseObj, messageType }) {
        HELPER_UTIL.dispatchCustomEvent(
            _EVENT_HELPER.triggerToastMessage,
            document,
            {
                toastType: 'common-errors',
                messageType: messageType,
                message: responseObj.message,
            }
        );
    }

    quantityElementAction({ line, quantity }) {
        const enable = () => {
            this.querySelectorAll('quantity-selector').forEach((el) =>
                el.setAttribute('is-disabled', 'false')
            );
        };

        const disable = () => {
            this.querySelectorAll('quantity-selector').forEach((el) =>
                el.setAttribute('is-disabled', 'true')
            );
        };

        const resetToPreviousValue = () => {
            this.querySelector(`[item-index="${line}"]`)
                .querySelectorAll('quantity-selector input')
                .forEach((el) => {
                    el.value = (Number(quantity) - 1).toString();
                });
        };

        return {
            enable,
            disable,
            resetToPreviousValue,
        };
    }

    updateCartTotal(data) {
        const cartTotal = data.total_price;
        const cartTotalEl = document.querySelectorAll('[cart-total]');

        [...cartTotalEl].forEach((el) => {
            el.textContent = Shopify.formatMoney(
                cartTotal,
                Shopify.money_format
            );
        });
    }

    cartCheckoutEl() {
        const hideContainerClass = 'hide';

        const show = () => {
            if (
                this.checkoutContainer.classList.contains(
                    hideContainerClass
                )
            ) {
                this.checkoutContainer.classList.remove(
                    hideContainerClass
                );
            }
        };

        const hide = () => {
            this.checkoutContainer.classList.add(
                hideContainerClass
            );
        };

        return {
            show,
            hide,
        };
    }

    renderElementsBasedOnCartItems(data) {
        const cartItemCount = this._getCartItemCount(data);
        this.dataset.cartitemcount = cartItemCount;

        if (cartItemCount > 0) {
            HELPER_UTIL.dispatchCustomEvent(
                _EVENT_HELPER.showCartRecommendations,
                this
            );
        } else {
            HELPER_UTIL.dispatchCustomEvent(
                _EVENT_HELPER.hideCartRecommendations,
                this
            );
        }
    }

    handleLineItem({ detail }) {
        const data = {
            id: detail.key,
            quantity: detail.quantity,
        };

        const sectionsToRender = HELPER_UTIL.sectionRenderUtil(
            this.cartIdentifier
        ).getSectionsString();

        this.quantityElementAction(detail).disable();

        HELPER_UTIL.fetchData({
            method: 'POST',
            url: `${window.Shopify.routes.root}cart/change.js?sections=${sectionsToRender}`,
            data: JSON.stringify(data),
            config: {
                headers: {
                    'Content-Type': 'application/json',
                },
            },

            onsuccess: (data) => {
                HELPER_UTIL.dispatchCustomEvent(
                    _EVENT_HELPER.triggerCartChange,
                    this,
                    {
                        sections: data.sections,
                    }
                );
            },

            onerror: (error) => {
                if (error.json) {
                    error.json().then((errorObj) => {
                        if (errorObj.status === 422) {
                            HELPER_UTIL.dispatchCustomEvent(
                                _EVENT_HELPER.triggerlineItemError,
                                this,
                                {
                                    errorObj: {
                                        lineItem: detail.key,
                                        responseObj: errorObj,
                                        messageType: 'error',
                                    },
                                }
                            );
                        }
                    });
                } else {
                    this.showDrawerToastMessage({
                        responseObj: {
                            message: 'Something went wrong. Please try again',
                        },
                        messageType: 'error',
                    });
                }
            },

            defaultCb: () => {
                this.quantityElementAction(detail).enable();
            },
        });
    }

    renderCartContents({ sections }) {
        if (!sections) return;

        const items = HELPER_UTIL
            .sectionRenderUtil(this.cartIdentifier)
            .getSectionsObject();

        items.forEach(({ sectionId, queryElement }) => {
            const html = sections[sectionId];

            if (typeof html !== 'string') return;

            const doc = new DOMParser().parseFromString(
                html,
                'text/html'
            );

            let source;

            if (queryElement === 'drawer-cart') {
                source = [...doc.querySelectorAll('drawer-cart')]
                    .find(
                        el => !el.querySelector(
                            'cart-drawer-component, drawer-cart'
                        )
                    );

                if (!source) {
                    console.error(
                        'Respuesta del carrito no válida: actualización cancelada.'
                    );
                    return;
                }
            } else {
                source = doc.querySelector(queryElement);
            }

            if (!source) return;

            document.querySelectorAll(queryElement).forEach(
                target => {
                    target.innerHTML = source.innerHTML;
                }
            );
        });
    }

    fetchAndRenderCartItems() {
        const sectionsToRender = HELPER_UTIL.sectionRenderUtil(
            this.cartIdentifier
        ).getSectionsString();

        HELPER_UTIL.fetchData({
            method: 'GET',
            url: `${window.Shopify.routes.root}cart/update.js?sections=${sectionsToRender}`,

            onsuccess: (data) => {
                HELPER_UTIL.dispatchCustomEvent(
                    _EVENT_HELPER.triggerCartChange,
                    this,
                    {
                        sections: data.sections,
                    }
                );
            },

            onerror: (error) => {
                console.log(error);
            },
        });
    }

    disconnectedCallback() {
        this.removeEventListener(
            drawerEvents.OnLineItemUpdate,
            this.handleLineItem.bind(this)
        );

        this.removeEventListener(
            drawerEvents.onQuantityChange,
            this.handleLineItem.bind(this)
        );

        this.removeEventListener(
            drawerEvents.triggerCartChange,
            this.renderCart.bind(this)
        );

        this.removeEventListener(
            drawerEvents.updateAndShowCart,
            this.fetchAndRenderCartItems.bind(this)
        );
    }
}

customElements.get('drawer-cart') ||
    customElements.define('drawer-cart', DrawerCart);


class CartPage extends DrawerCart {
    constructor() {
        super();
    }

    renderElementsBasedOnCartItems(data) {
        const cartItemCount = this._getCartItemCount(data);

        if (cartItemCount > 0) {
            if (this.checkoutContainer) {
                this.cartCheckoutEl().show();
            }
        } else {
            if (this.checkoutContainer) {
                this.cartCheckoutEl().hide();
            }
        }
    }

    showDrawerToastMessage({ responseObj, messageType }) {
        const toastEl = this.querySelector('toast-message');

        toastEl.toast({
            message: responseObj.message,
            messageType: messageType,
        });
    }
}

customElements.get('cart-page') ||
    customElements.define('cart-page', CartPage);


class DrawerItem extends HTMLElement {
    constructor() {
        super();

        this.itemKey = this.getAttribute('item-key');

        this.removeItemElement = this.querySelectorAll(
            '[remove-lineItem]'
        );

        [...this.removeItemElement].forEach((el) => {
            el.addEventListener(
                'click',
                this.dispatchLineItemUpdate.bind(this)
            );

            el.addEventListener('keyup', (e) => {
                if (e.key === 'Enter') {
                    this.dispatchLineItemUpdate();
                }
            });
        });

        this.addEventListener(
            _EVENT_HELPER.onQuantityChange,
            this.dispatchLineItemUpdate.bind(this)
        );

        document.addEventListener(
            _EVENT_HELPER.triggerlineItemError,
            this.showLineItemError.bind(this)
        );
    }

    dispatchLineItemUpdate(e) {
        const productQuantity = e?.detail.quantity;

        let detail = {
            key: this.itemKey,
            quantity: productQuantity ? productQuantity : '0',
        };

        if (
            detail.quantity === '0' &&
            e?.target.closest('[animation-slide-left]')
        ) {
            Motion.animate(
                e?.target.closest('[animation-slide-left]'),
                {
                    x: 40,
                    opacity: 0,
                },
                {
                    duration: parseFloat(0.3),
                    ease: 'cubic-bezier(.75,0,.175,1)',
                }
            );
        }

        HELPER_UTIL.dispatchCustomEvent(
            _EVENT_HELPER.OnLineItemUpdate,
            this,
            detail
        );
    }

    handleLineItemErrorUpdate(errorObj) {
        let customMessageComponent =
            this.querySelector('custom-message') ||
            this.nextElementSibling.querySelector('custom-message');

        console.log(errorObj);

        customMessageComponent.showCustomMessage({
            errorMessage: errorObj.responseObj.message,
            messageType: errorObj.messageType,
        });
    }

    resetQuantitySelector() {
        this.querySelector('quantity-selector input').value =
            this.getAttribute('item-quantity');
    }

    showLineItemError(event) {
        const { errorObj } = event.detail;

        if (
            errorObj &&
            errorObj.lineItem === this.itemKey
        ) {
            this.handleLineItemErrorUpdate(errorObj);
            this.resetQuantitySelector();
        }
    }

    disconnectedCallback() {
        this.removeEventListener(
            _EVENT_HELPER.onQuantityChange,
            this.dispatchLineItemUpdate.bind(this)
        );

        [...this.removeItemElement].forEach((el) => {
            el.removeEventListener(
                'click',
                this.dispatchLineItemUpdate.bind(this)
            );

            el.removeEventListener('keyup', (e) => {
                if (e.key === 'Enter') {
                    this.dispatchLineItemUpdate();
                }
            });
        });
    }
}

customElements.get('drawer-item') ||
    customElements.define('drawer-item', DrawerItem);


/* Animación de botones adicionales de pago */

class AdditionalCheckoutButtonsAnimation extends HTMLElement {
    constructor() {
        super();

        this.toggleButton = this.querySelector(
            '[toggle-payment-buttons]'
        );

        this.toggleButton?.addEventListener(
            'click',
            this.togglePaymentButtons.bind(this)
        );

        this.buttonsWrapper = this.querySelector(
            '[checkout-buttons-wrapper]'
        );
    }

    togglePaymentButtons(e) {
        e.preventDefault();

        this.toggleButton.classList.toggle(
            'show-payment-options'
        );

        this.setAttribute(
            'style',
            `--button-wrapper-height:${this.buttonsWrapper?.firstElementChild.offsetHeight}px`
        );

        this.buttonsWrapper?.classList.toggle('active');
    }
}

customElements.get('additional-checkout-buttons-animation') ||
    customElements.define(
        'additional-checkout-buttons-animation',
        AdditionalCheckoutButtonsAnimation
    );


/*
  CORRECCIÓN CYBERDAYS / FLAWLESS

  Cuando un producto tiene cantidad 1,
  permite eliminarlo mediante el botón menos.

  Utiliza el evento original del tema para
  actualizar el carrito lateral.
*/

(function enableRemoveLastCartItem() {
    if (window.__flawlessRemoveLastCartItemReady) return;

    window.__flawlessRemoveLastCartItemReady = true;

    document.addEventListener(
        'click',
        function(event) {
            const button = event.target.closest('button');

            if (!button) return;

            const selector = button.closest(
                'quantity-selector'
            );

            if (!selector) return;

            const drawerItem = selector.closest(
                'drawer-item'
            );

            if (
                !drawerItem ||
                typeof drawerItem.dispatchLineItemUpdate !== 'function'
            ) {
                return;
            }

            const input = selector.querySelector('input');

            if (
                !input ||
                Number(input.value) !== 1
            ) {
                return;
            }

            const minusButton = selector.querySelector(
                'button'
            );

            const isMinus =
                button === minusButton ||
                button.matches(
                    '[name="minus"], [data-quantity-minus], [data-minus]'
                );

            if (!isMinus) return;

            event.preventDefault();
            event.stopImmediatePropagation();

            drawerItem.dispatchLineItemUpdate();
        },
        true
    );
})();
